import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Skeleton } from "@/shared/components/ui/skeleton";

/** Skeleton shown while the admin user detail loads. */
export function UserDetailLoading() {
  return (
    <div data-testid="user-detail-loading" className="space-y-6">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-32 w-full" />
      <Skeleton className="h-48 w-full" />
    </div>
  );
}

interface UserDetailErrorProps {
  readonly error: unknown;
}

/** Error panel of the user detail: a 404 reads as "not found", anything else is generic. */
export function UserDetailError({ error }: UserDetailErrorProps) {
  const { t } = useTranslation();
  const status = (error as { status?: number } | null)?.status;
  return (
    <div data-testid="user-detail-error" className="space-y-4">
      <Link
        to="/users"
        className="inline-flex items-center gap-1 font-sans text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" />
        {t("users.detail.back")}
      </Link>
      <div className="rounded-lg border border-destructive/30 bg-destructive/5 p-6 text-center">
        <p className="font-sans text-sm font-medium text-destructive">
          {status === 404 ? t("users.detail.notFound") : t("users.detail.error")}
        </p>
      </div>
    </div>
  );
}
